import React from "react"
import Link from "../../adapters/Link"
import { ArrowUp, ArrowUpRight, Mail, MapPin, Phone } from "lucide-react"
import { CONTACT } from "../../lib/site"
import { T } from "../../lib/i18n"
export function SiteFooter({ lang }) {
  const t = T[lang]
  return (
    <footer className="site-footer">
      <div className="site-footer-panel">
        <div className="site-footer-main">
          <div className="site-footer-brand">
            <Link
              href={`/${lang}`}
              className="site-footer-wordmark"
              aria-label={`Halal Correct France — ${t.home}`}
            >
              <span className="site-footer-logo">
                <img
                  src="/images/hcc-logo.png"
                  alt="Logo Halal Correct France"
                  width={72}
                  height={62}
                />
              </span>
              <span>
                Halal Correct<span>France</span>
              </span>
            </Link>
            <p>{t.footerMember}</p>
          </div>
          {[
            [t.useful, t.useLinks],
            [t.contactUs, t.contactLinks],
          ].map(([title, links]) => (
            <nav key={title} aria-label={title}>
              <h2 className="site-footer-label">{title}</h2>
              <ul className="site-footer-links">
                {links.map(([label, to]) => (
                  <li key={to}>
                    <Link href={to}>
                      {label}
                      <ArrowUpRight className="size-3.5" aria-hidden />
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>
        <address className="site-footer-contact">
          <div className="site-footer-address">
            <span className="site-footer-contact-icon">
              <MapPin className="size-5" aria-hidden />
            </span>
            <div>
              <h2 className="site-footer-label">{t.findUs}</h2>
              <p>
                {CONTACT.address}
                <br />
                {CONTACT.city}
              </p>
            </div>
          </div>
          <div className="site-footer-direct">
            <a href={CONTACT.phoneHref}>
              <span className="site-footer-contact-icon">
                <Phone className="size-4" aria-hidden />
              </span>
              {CONTACT.phone}
              <ArrowUpRight className="size-3.5" aria-hidden />
            </a>
            <a href={`mailto:${CONTACT.email}`}>
              <span className="site-footer-contact-icon">
                <Mail className="size-4" aria-hidden />
              </span>
              {CONTACT.email}
              <ArrowUpRight className="size-3.5" aria-hidden />
            </a>
          </div>
        </address>
        <div className="site-footer-bottom">
          <p>{t.copyright}</p>
          <a
            href="#"
            className="site-footer-top"
            aria-label={lang === "fr" ? "Retour en haut" : "Back to top"}
          >
            <ArrowUp className="size-4" aria-hidden />
          </a>
        </div>
      </div>
    </footer>
  )
}
